import React from "react";
import { EmbedScriptInner } from "../Components/Dialog/EmbedScriptInner";
import { CampaignActionType, ICampaign } from "../../App/Typings/Campaigns";
import { PartialDialog } from "./DialogState";

export default function EmbedScriptState(
  handleDisplayDialog: (dialog: PartialDialog) => void,
  handleClearDialog: () => void,
) {
  const handleOpenEmbedScriptDialog: CampaignActionType = (campaign: ICampaign) => {
    handleDisplayDialog({
      "aria-label": "Get Embed Script",
      children: React.createElement(EmbedScriptInner, {
        campaignId: campaign.id,
        campaignName: campaign.name,
        forms: campaign.forms,
        handleClearDialog,
      }),
      maxWidth: "md",
    });
  };
  return {
    handleOpenEmbedScriptDialog,
  };
}
